export default function BrandLogo({ className = "" }) {
  return (
    <img
      src="/images/brand/beep-beep-logo.png?v=2"
      alt="بيب بيب"
      className={`block bg-transparent rounded-none shadow-none object-contain ${className}`}
    />
  );
}
